module.exports = __webpack_public_path__ + "img/sanic_dead.8556047e.png";